var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tabs',{attrs:{"show-arrows":"","height":"35"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'administrative-weekly-report',
                query: {
                    employeeId: _vm.$route.query.employeeId
                }
            }}},[_vm._v(" "+_vm._s(_vm.$t('AdministrativeReport.reports'))+" ")]),(!_vm.firstLevel)?_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'administrative-double-visits',
                query: {
                    employeeId: _vm.$route.query.employeeId
                }
            }}},[_vm._v(" "+_vm._s(_vm.$t('AdministrativeReport.double-visits'))+" ")]):_vm._e(),_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'administrative-visits',
                query: {
                    employeeId: _vm.$route.query.employeeId
                }
            }}},[_vm._v(" "+_vm._s(_vm.$t('AdministrativeReport.visits'))+" ")]),_c('v-tab',{staticClass:"text-capitalize",attrs:{"to":{ 
                name: 'debt-record-visits'
            }}},[_vm._v(" "+_vm._s(_vm.$t('AdministrativeReport.debts'))+" ")]),_c('v-tabs-slider',{attrs:{"color":"primary"}})],1),(!_vm.$route.query.preview)?_c('v-divider',{staticClass:"mb-2"}):_vm._e(),(_vm.loading)?_c('loader'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }